import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Helmet } from 'react-helmet';
import { Trans, useTranslation } from 'react-i18next';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import * as leadAction from '../../store/actions/lead.action';
import * as types from '../../store/actions/types';
import { RootState } from '../../store/reducers';
import { checkIsUserPaid, getLocalStorageValue, handleToast, historyPath, historyPush, isUserLoggedIn, isUserRole, isValidEmail, localStorageKeyValue, sawEBook, setLocalStorageValue, updateUser } from '../../utils/handler';
import { leadPayloadForm } from '../types/lead.types';
import { NumberInput } from './CommonPages';

export const Survey: React.FC<{}> = (props: any): JSX.Element => {
  const { t } = useTranslation();
  let [agentName, setAgentName] = useState('Jeff');
  const history = useHistory();
  const [preferredContact, setPreferredContact] = useState('Email');
  const [preferText, setPreferText] = useState(false);
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState(getLocalStorageValue(localStorageKeyValue.userEmail));
  const [offerAmount, setOfferAmount] = useState(getLocalStorageValue(localStorageKeyValue.offerAmount));
  const [questionsAny, setQuestionsAny] = useState('');
  const [formSubmited, setFormSubmitted] = useState(false);
  const [phoneValidationError, setPhoneValidationError] = useState('');
  const [loaderBtn, setLoaderBtn] = useState(false);
  const [preferredTime, setPreferredTime] = useState<any>(null);
  const [callAt, setCallAt] = useState('Morning');
  const [userName, setUserName] = useState('');
  const [leadDetails, setLeadDetails] = useState({ isSurveyCompleted: false, UID: '', domainName: '' });
  const { myProfile } = useSelector((state: RootState) => state.userReducer);
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);
  const [beSeen, setBeSeen] = useState('');
  const [deadLine, setDeadLine] = useState<any>(null);
  // const [ebookLoader, setEbookLoader] = useState<boolean>(false)
  const dispatch = useDispatch();

  useEffect(() => {
    if (myProfile && !_.isEmpty(myProfile)) {
      const name = myProfile.name;
      setUserName(name || '');
      getMyLeads();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myProfile]);

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    const email = params.get('email');
    const brokerName = params.get('agentName') || '';
    setAgentName(brokerName);
    setEmail(email || '');
    setLocalStorageValue(localStorageKeyValue.userEmail, email || '');
    if (!isUserLoggedIn()) {
      dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
    }
  }, [myProfile, history, dispatch]);

  const getMyLeads = () => {
    leadAction
      .getMyLeads()
      .then((res) => {
        let lead = res[0];
        dispatch({ type: types.LEAD_DETAILS, payload: lead });
        if (isUserRole()) {
          if (lead && checkIsUserPaid(lead.payments)) {
            loadLeadDetails(lead);
          } else {
            history.push('/hire-consultant');
          }
        } else {
          historyPush(historyPath.dashboard);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  let loadLeadDetails = (leadDetails: any) => {
    if (leadDetails) {
      let leadDeaDLine = deadLine || leadDetails.deadLine;
      leadDetails.offerAmount = offerAmount || leadDetails.offerAmount;
      leadDetails.questionsAny = questionsAny || leadDetails.questionsAny;
      // leadDetails.preferredContact = preferredContact || leadDetails.preferredContact
      leadDetails.beSeen = beSeen || leadDetails.beSeen || '';
      leadDetails.preferText = preferText || leadDetails.preferText;
      leadDetails.preferredTime = preferredTime || leadDetails.preferredTime;
      leadDetails.email = email || myProfile.email;
      leadDetails.phone = phone || myProfile.phone || '';

      if (leadDetails.consultant) {
        setAgentName(leadDetails.consultant.name);
      }
      setOfferAmount(leadDetails.offerAmount || '');
      setQuestionsAny(leadDetails.questionsAny || '');
      setPreferredContact(leadDetails.preferredContact || '');
      setBeSeen(leadDetails.beSeen);
      setPreferText(leadDetails.preferText);
      setPhone(leadDetails.phone);
      setEmail(leadDetails.email);

      if (leadDetails.preferredTime && leadDetails.preferredTime !== 'Invalid date') {
        let callTime = moment(leadDetails.preferredTime).format('HH.mm') === '14.30' ? 'Noons' : 'Mornings';
        setPreferredTime(new Date(leadDetails.preferredTime));
        setCallAt(callTime);
      }
      if (leadDeaDLine) {
        setDeadLine(new Date(leadDeaDLine));
      }
      setLeadDetails(leadDetails);
    }
  };
  const submit = () => {
    setFormSubmitted(true);
    if (isFormValid()) {
      if (myProfile && !_.isEmpty(myProfile)) {
        setLoaderBtn(true);
        let payload: leadPayloadForm = {
          questionsAny,
          preferredContact,
          preferText: false,
          phone,
          email,
          beSeen,
        };
        if (moment(preferredTime).isValid()) {
          payload.preferredTime = moment(preferredTime).utc().format();
        }
        payload.deadLine = deadLine && moment(deadLine).isValid() ? moment(deadLine).utc().format() : null;

        if (preferredContact === 'Phone') {
          payload.preferText = preferText;
        }
        if (offerAmount) {
          payload.offerAmount = offerAmount;
        }
        if (!leadDetails.isSurveyCompleted) {
          payload.isSurveyCompleted = true;
        }
        let leadUID = leadDetails?.UID;
        if (leadUID) {
          dispatch({ type: types.LEAD_DETAILS, payload: { ...leadDetails, phone, email } });
          updateUser(email, phone, myProfile)
            .then((res: any) => {
              leadAction
                .updateLead(leadUID, payload)
                .then((res) => {
                  if (res) {
                    if (leadDetails.isSurveyCompleted) {
                      handleToast({ message: t('Domain details updated') }, 'success');
                    } else {
                      handleToast({ message: t('Thank you for the information. Your Domain Broker will be conducting some preliminary research regarding,') + (' ' + leadDetails.domainName + ' ') + t(`and will get back to you in one to two business days.`) }, 'success');
                    }
                    dispatch({ type: types.LEAD_DETAILS, payload: { ...leadDetails, ...payload } });
                    // handleToast({ message: `Thank you for the information. Your Domain Broker will be conducting some preliminary research regarding ${leadDetails.domainName}, and will get back to you in one to two business days.` }, 'success')
                    historyPush(historyPath.dashboard);
                  }
                  setLoaderBtn(false);
                  setFormSubmitted(false);
                })
                .catch((e) => {
                  errorHandler(e);
                });
            })
            .catch((e) => {
              errorHandler(e);
            });
        } else {
          dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
          setLoaderBtn(false);
          setFormSubmitted(false);
        }
      } else {
        dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
        handleToast({ message: 'Please Login to save the details' });
      }
    }
  };

  const errorHandler = (e: any) => {
    handleToast({ message: e });
    setLoaderBtn(false);
    setFormSubmitted(false);
  };
  const isFormValid = () => {
    if (preferredContact === 'Phone') {
      if (!phone) {
        handleToast({ message: t('Please enter valid Phone number') });
        setPhoneValidationError(t('Please Enter Phone number'));
        return false;
      } else if (phone && !isValidPhoneNumber(phone)) {
        handleToast({ message: t("'Please enter valid Phone number'") });
        setPhoneValidationError(t('Invalid phone number'));
        return false;
      }
    }
    if (preferredContact === 'Email' && (email === '' || isValidEmail(email))) {
      handleToast({ message: t('Please enter valid Email') });
      return false;
    }

    return preferredContact ? true : false;
  };

  const phoneNumberChange = (value: any) => {
    if (!value || (value && isValidPhoneNumber(value))) {
      setPhoneValidationError('');
    }
    if (formSubmited && value && !isValidPhoneNumber(value)) {
      setPhoneValidationError(t('Invalid phone number'));
    }
    setPhone(value);
  };

  const handlerPrefertime = (type: string) => {
    let preferTime = new Date(new Date(preferredTime || new Date()).setHours(type === 'Mornings' ? 8 : 14, 30));
    setPreferredTime(preferTime);
    setCallAt(type);
  };

  // const eBookDownload = () => {
  //     setEbookLoader(true)
  //     let ebookElement = document.getElementById("EbookElement")
  //     let leadUID = leadDetails.UID
  //     leadAction.downloadEbook(leadUID).then(res => {
  //             ebookElement?.click()
  //             setEbookLoader(false)
  //     }).catch(e => {
  //     })
  // }
  return (
    <div className="container">
      <Helmet>
        <title>Domain Survey - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <div className="content-body">
        <div className="title">{t('Survey')}</div>
        <div className="form-row justify-content-center">
          <div className="payment-response">
            <div className="">
              {/* <strong className="success-content" ><i className="far fa-check-circle "></i> Thanks for paying $19.95 as a initial fee</strong> */}
              <div>
                <strong>{t('Your free E-book is here')}:</strong>
                <a href={sawEBook} download="saw-e-book.pdf" className=" theme-color theme-a-tag ml-1 c-pointer ">
                  {t('Download E-book')}
                </a>
                {/* <span className={(ebookLoader ? " disable" : "theme-color theme-a-tag ml-1 c-pointer")} onClick={e => !ebookLoader && eBookDownload()}>
                                Download E-book
                            </span> */}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3">
          <p>
            {t('Hi')} {userName},<br />
            <Trans>
              {t('agent_intro', { agentName })}
              <b></b>
            </Trans>
            <br />
            {t('Please complete this survey. Try not to leave anything out. Something you might not think is essential could be very important to me.')}
            <br />
            {t('Once I have had the opportunity to review your case and conduct some reconnaissance, I will be in touch with our next steps. I am looking forward to getting started!')}
            <br />
          </p>
          <div className="form-row">
            <div className="">
              <div className="form-group ">
                <label className="mt-2 fw-600">{t('Do you have a budget in mind?')}</label>
                <NumberInput placeholder="$" value={offerAmount} name="offerAmount" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOfferAmount(e.target.value)} />
                {/* <input
                                autoComplete="off"
                                type="number"
                                className="form-control saw-input"
                                name="offerAmount"
                                placeholder="$"
                                onKeyDown={e => { ([189, 69, 109, 187, 107].includes(e.keyCode)) && e.preventDefault() }}
                                value={offerAmount}
                                min={0}
                                onChange={e => { setOfferAmount(e.target.value) }}
                            /> */}
              </div>
              <div className="form-group">
                <label className="mt-2 fw-600">{t('Do you have a deadline?')}</label>
                <DatePicker minDate={new Date()} isClearable selected={deadLine} className="form-control saw-input" onChange={(date: any) => setDeadLine(date)} />
              </div>

              <div className="form-group ">
                <label className=" fw-600">{t(' Have you contacted the domain owner or seller before and what was the result?')}</label>
                <textarea cols={5} rows={3} autoComplete="off" className="form-control saw-input" name="beSeen" value={beSeen} onChange={(e) => setBeSeen(e.target.value)} />
              </div>
              <div className="form-group">
                <div className="form-group ">
                  <label className=" fw-600">{t('Any questions, comments?')}</label>
                  <textarea cols={5} rows={3} autoComplete="off" className="form-control saw-input" name="questionsAny" value={questionsAny} onChange={(e) => setQuestionsAny(e.target.value)} />
                </div>
              </div>
              <div className="form-group ">
                <div className="choose-widget">
                  <label className="mt-2 fw-600">{t('How would you like to be contacted?')}</label>
                  <div className="f-bold d-flex  options">
                    <div className="form-check form-check-inline  ">
                      <input className="form-check-input" checked={preferredContact === 'Phone'} onChange={() => setPreferredContact('Phone')} type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                      <label className="mt-2  " htmlFor="inlineRadio1 ">
                        {t('Mobile')}
                      </label>
                    </div>
                    <div className="form-check form-check-inline ml-2 ">
                      <input className="form-check-input " checked={preferredContact === 'Email'} onChange={() => setPreferredContact('Email')} type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                      <label className="mt-2 " htmlFor="inlineRadio2">
                        {t('Email')}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form-group mt-2">
                  {preferredContact === 'Phone' ? (
                    <div className="mt-2">
                      <div className="">
                        {/* <span className="fw-600">{t("Phone number")}</span> */}
                        <div className="phone-contact-details mt-2">
                          <PhoneInput international defaultCountry={localCountryStr} placeholder={t('Enter phone number')} value={phone} name="phone" onChange={(data) => phoneNumberChange(data || '')} className={'form-control saw-input ' + (phoneValidationError ? 'is-invalid' : '')} />

                          <div className="form-check mt-2 ml-1 fs-14 custom-checkbox">
                            <input name="preferText" type="checkbox" checked={preferText} onChange={(e) => setPreferText(e.target.checked)} className="saw-check-box form-check-input " />
                            <label className="fw-600 form-check-label">{t('Phone Text')}</label>
                          </div>
                        </div>
                        {phoneValidationError !== '' && <div className="text-danger">{t(phoneValidationError)}</div>}
                        <div className="lh-20">
                          <label className="mt-2 fst-italic fs-13 fs-italic ">{t('Please note that any SMS and/or data fees may apply depending on your provider')}</label>
                        </div>
                      </div>
                      <div className=" preferred-input ">
                        <label className="fw-600">{t('Preferred day and time for contact:')}</label>
                        <div className="d-flex ">
                          <DatePicker
                            placeholderText={t('MM/DD/YYYY')}
                            className="form-control saw-input"
                            selected={preferredTime}
                            minDate={new Date()}
                            onChange={(date) => {
                              setPreferredTime(date);
                            }}
                            dateFormat="MM/dd/yyyy"
                          />
                          <select value={callAt} onChange={(e) => handlerPrefertime(e.target.value)} className="form-control ml-2 select-box">
                            <option selected value="Mornings">
                              {t('Morning')}
                            </option>
                            <option value="Noons">{t('Afternoon')}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ) : (
                    preferredContact === 'Email' && (
                      <div className="">
                        {/* <label className="fw-600">{t("Email")}</label> */}
                        <input autoComplete="off" type="email" className={'form-control ' + (formSubmited ? (email === '' || isValidEmail(email) ? 'is-invalid' : 'is-valid') : '')} name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        <div className="invalid-feedback fs-13">{t('Please Enter Valid Email')}</div>
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="row justify-content-center mt-2">
                <button className="btn  fs-14  btn-grad" disabled={loaderBtn} onClick={submit}>
                  {loaderBtn ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : t('save')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Survey;
